import Typography from '@mui/material/Typography';
import {formatCopy} from 'utils/typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {LinkPopover} from '@vedmarket/ui-kit';
import HelpPanel from '../../help-panel';
import GuideList from './components/list';

const Guide = ({ handleApplyCode, isExpandedGuideTab, code }: GuideProps) => {
  const { t } = useTranslation();

  const [ isExpanded, setIsExpanded ] = useState(isExpandedGuideTab);

  const onApplyCode = (value: string) => {
    setIsExpanded(false);
    handleApplyCode(value);
  };

  return <div className='guide'>
    <HelpPanel
      title={t('common__text__guide')}
      expanded={isExpanded}
      onChange={setIsExpanded}
      headerHelp={<LinkPopover
        linkText={t('calc__help__guideLink')}
        text={formatCopy(t('calc__help__guide'))}
      />}
    >
      <GuideList handleApplyCode={onApplyCode} code={code} />
    </HelpPanel>
  </div>;
};

export default Guide;
